import { themeStyle } from "../../components/Components";
import React, { useEffect, useState, useRef, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Sidebar from "../../components/Sidebar";
import PropTypes from "prop-types";
import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";
import { API_URL, MAIN_TITLE, alertMessage } from "../../actions/auth";
import Paper from "@mui/material/Paper";
import Fab from "@mui/material/Fab";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import TextField from "@mui/material/TextField";
import PublishIcon from "@mui/icons-material/Publish";
import Avatar from "@mui/material/Avatar";
import axios from "axios";
import CircularProgress from "@mui/material/CircularProgress";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import Drawer from "@mui/material/Drawer";
import AddBoxIcon from "@mui/icons-material/AddBox";
import Checkbox from "@mui/material/Checkbox";
import moment from "moment";
import DeleteIcon from "@mui/icons-material/Delete";
import ButtonBase from "@mui/material/ButtonBase";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import DoneIcon from "@mui/icons-material/Done";
import ClearIcon from "@mui/icons-material/Clear";
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import html2pdf from "html3pdf";

function makeid(length) {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

function FeesParent() {
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const [transactions, setTransactions] = useState([]);

  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const [month, setMonth] = useState(1);
  const [year, setYear] = useState("2025");

  const [open2, setOpen2] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [isLoadingDownload, setIsLoadingDownload] = useState(false);

  function createAlert(type, title, message) {
    dispatch(alertMessage(type, title, message));
  }

  if (state.auth.refresh == "REFRESH_DATA") {
    getData();
    dispatch({ type: "REFRESH_DATA", payload: null });
  }

  useEffect(() => {
    if (state.auth.isLoading) {
      dispatch({ type: "ENTRY_PAGE", payload: window.location.pathname });
      navigate("/", { replace: true });
    } else {
      getData();
    }
  }, []);

  const [isSubmitting, setIsSubmitting] = useState(false);

  function getData() {
    var body = {};
    const config = {
      headers: {
        Authorization: state.auth.token,
        "Content-Type": "application/json",
      },
    };

    body["institution_id"] = state.auth.user.institution_id;
    body["student_id"] = state.auth.student.user_id;
    body = JSON.stringify(body);

    axios
      .post(API_URL + "/get_user_transactions", body, config)
      .then((res) => {
        setTransactions(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        createAlert("ERROR", "Error", "An error occured.");
      });
  }

  function getContent() {
    if (transactions.length == 0) {
      return (
        <div
          style={{
            marginTop: "200px",
            height: "100px",
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div style={{ textAlign: "center" }}>
            <Fab
              size="large"
              style={{
                border: "3px solid #aaa",
                boxShadow: "none",
                backgroundColor: "transparent",
              }}
              aria-label="add"
            >
              <PriorityHighIcon
                style={{
                  color: "grey",
                }}
              />
            </Fab>
            <br />
            <h4 style={{ color: "grey" }}>
              No transactions have been added yet.
            </h4>
          </div>
        </div>
      );
    } else {
      return (
        <div style={{ width: "100vw", fontSize: "18px" }}>
          <h2>All transactions</h2>
          <Grid
            container
            style={{
              paddingBottom: "5px",
              marginBottom: "5px",
              borderBottom: "1px solid #aaa",
            }}
          >
            <Grid item md={1}>
              Sr.
            </Grid>
            <Grid item md={3}>
              Transaction ID
            </Grid>
            <Grid item md={3}>
              Full Name
            </Grid>
            <Grid item md={2}>
              Total Payment
            </Grid>
            <Grid item md={2}>
              Phone Number
            </Grid>
            <Grid
              item
              md={1}
              style={{ display: "flex", justifyContent: "center" }}
            >
              Status
            </Grid>
          </Grid>
          {transactions.map((item, index) => (
            <Accordion
              expanded={expanded == index ? true : false}
              onClick={() => {
                setExpanded(expanded == index ? -1 : index);
              }}
              style={{
                borderRadius: "15px",
                width: "100%",
                marginBottom: "5px",
              }}
            >
              <AccordionSummary
                style={{
                  padding: state.auth.isMobile
                    ? "5px 15px 25px 15px"
                    : "5px 15px 5px 15px",
                  borderRadius: "5px",
                  fontWeight: 600,
                  height: "50px",
                  color: themeStyle.primaryColor,
                  fontSize: "18px",
                  alignItems: "center",
                  borderBottom: "2px solid white",
                  textAlign: "left",
                }}
                expandIcon={
                  <ExpandMoreIcon
                    style={{
                      fontSize: "3.25vh",
                      color: themeStyle.primaryColor,
                    }}
                  />
                }
              >
                <Grid container style={{ marginTop: "15px" }}>
                  <Grid item md={1}>
                    {index + 1}
                  </Grid>
                  <Grid item md={3}>
                    {item.transaction_id}
                  </Grid>

                  <Grid item md={3}>
                    {item.extra_data.full_name}
                  </Grid>
                  <Grid item md={2}>
                    {item.total_customer}
                  </Grid>
                  <Grid item md={2}>
                    {item.extra_data.phone_number}
                  </Grid>
                  <Grid
                    item
                    md={1}
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <ButtonBase
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        backgroundColor: item.status
                          ? themeStyle.primaryColor
                          : "#ff3333",
                        padding: "2px",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "6px",
                      }}
                    >
                      {item.status ? (
                        <DoneIcon
                          style={{ color: "white", fontSize: "22px" }}
                        />
                      ) : (
                        <ClearIcon
                          style={{ color: "white", fontSize: "22px" }}
                        />
                      )}
                    </ButtonBase>
                  </Grid>
                </Grid>
              </AccordionSummary>

              <AccordionDetails
                style={{ borderRadius: "15px",
                  backgroundColor: "white",
                  color: themeStyle.primaryColor,
                  textAlign: "left",
                  width: "40vw",
                  border: "2px dotted #aaa",
                }}
              >
                <div
                  style={{ padding: "50px", marginTop: "-20px" }}
                  id={"pdf-element"}
                >
                  <div
                    style={{
                      width: "100%",
                      height: "60vh",
                    }}
                  >
                    <div
                      style={{
                        textAlign: "center",
                        fontSize: "20px",
                        fontWeight: "bold",
                      }}
                    >
                      {MAIN_TITLE}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        style={{
                          marginTop: "25px",
                          fontSize: "18px",
                          fontWeight: "bold",
                          display: "flex",
                        }}
                      >
                        <div style={{ color: themeStyle.primaryColor }}>
                          Fee Recipt Number:
                        </div>
                        <div style={{ color: "black", marginLeft: "15px" }}>
                          {item.receipt_number}
                        </div>
                      </div>
                      <div
                        style={{
                          marginTop: "25px",
                          fontSize: "18px",
                          fontWeight: "bold",
                          display: "flex",
                        }}
                      >
                        <div style={{ color: themeStyle.primaryColor }}>
                          Date:
                        </div>
                        <div style={{ color: "black", marginLeft: "15px" }}>
                          {moment(item.created_at, "YYYY-MM-DD").format(
                            "DD-MM-YYYY"
                          )}
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        style={{
                          marginTop: "25px",
                          fontSize: "18px",
                          fontWeight: "bold",
                          display: "flex",
                        }}
                      >
                        <div style={{ color: themeStyle.primaryColor }}>
                          Student Name:
                        </div>
                        <div style={{ color: "black", marginLeft: "15px" }}>
                          {state.auth.student.full_name}
                        </div>
                      </div>
                      <div
                        style={{
                          marginTop: "25px",
                          fontSize: "18px",
                          fontWeight: "bold",
                          display: "flex",
                        }}
                      >
                        <div style={{ color: themeStyle.primaryColor }}>
                          CHSID:
                        </div>
                        <div style={{ color: "black", marginLeft: "15px" }}>
                          {state.auth.student.user_id}
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        display: "flex",
                        marginBottom: "25px",
                      }}
                    >
                      <div style={{ color: themeStyle.primaryColor }}>
                        Class:
                      </div>
                      <div style={{ color: "black", marginLeft: "15px" }}>
                        {state.auth.student.class_id +
                          state.auth.student.division}
                      </div>
                    </div>

                    <div
                      style={{
                        width: "100%",
                        height: "2px",
                        backgroundColor: "black",
                      }}
                    />
                    <br />

                    {Object.entries(JSON.parse(item.extra_data.udf1)).map(
                      ([key, value]) => (
                        <div
                          style={{
                            fontSize: "18px",
                            fontWeight: "bold",
                            display: "flex",
                            marginBottom: "25px",
                            justifyContent: "space-between",
                          }}
                        >
                          <div style={{ color: themeStyle.primaryColor }}>
                            {key}
                          </div>
                          <div style={{ color: "black", marginLeft: "15px" }}>
                            {value}
                          </div>
                        </div>
                      )
                    )}

                    <div
                      style={{
                        width: "100%",
                        height: "2px",
                        backgroundColor: "black",
                      }}
                    />
                    <br />
                    <div
                      style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        display: "flex",
                        marginBottom: "25px",
                        justifyContent: "flex-end",
                      }}
                    >
                      <div style={{ color: themeStyle.primaryColor }}>
                        Total Amount:
                      </div>
                      <div style={{ color: "black", marginLeft: "15px" }}>
                        {item.total_customer}
                      </div>
                    </div>
                    <br />
                    <br />
                    <div
                      style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        display: "flex",
                        marginBottom: "25px",
                        justifyContent: "flex-start",
                      }}
                    >
                      <div style={{ color: themeStyle.primaryColor }}>
                        Transaction ID:
                      </div>
                      <div style={{ color: "black", marginLeft: "15px" }}>
                        {item.transaction_id}
                      </div>
                    </div>
                    <br />
                    <br />
                    <br />
                    <br />
                    <div
                      style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        width: "200px",
                        borderTop: "2px dashed black",
                        paddingTop: "10px",
                      }}
                    >
                      <div style={{ color: themeStyle.primaryColor }}>
                        Receiver's Signature
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "flex-end",
                  }}
                >
                  <Button
                    style={{
                      height: "35px",
                      margin: "6px 0px 15px 0px",
                      border: "1px solid #3182bd",
                      backgroundColor: themeStyle.primaryColor,
                      boxShadow: "none",
                    }}
                    variant={"contained"}
                    onClick={() => {
                      setIsLoadingDownload(true);
                      var element = document.getElementById("pdf-element");
                      html2pdf(element, {
                        jsPDF: {
                          unit: "in",
                          format: "letter",
                          orientation: "landscape",
                        },
                        documentProperties: {
                          title: "Fee Recipt - " + item.transaction_id,
                        },
                      }).then((_) => {
                        setIsLoadingDownload(false);
                        createAlert(
                          "SUCCESS",
                          "Completed",
                          "Attendance downloaded in pdf"
                        );
                      });
                    }}
                  >
                    <h4>Download PDF</h4>
                  </Button>
                </div>
                {isLoadingDownload ? (
                  <div
                    style={{ borderRadius: "15px",
                      marginTop: "20px",
                      padding: "20px",
                      width: "100%",
                      backgroundColor: "white",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    <CircularProgress />
                    <h3 style={{ textAlign: "center" }}>
                      Downloading Fee Recipt
                      <br />
                      This might take a couple of seconds...
                    </h3>
                  </div>
                ) : (
                  <Fragment></Fragment>
                )}
              </AccordionDetails>
            </Accordion>
          ))}
        </div>
      );
    }
  }

  if (!state.auth.isLoading) {
    if (state.auth.isAuthenticated) {
      if (state.auth.user.is_parent) {
        return (
          <Fragment>
            <Modal
              aria-labelledby="transition-modal-title"
              aria-describedby="transition-modal-description"
              open={open2}
              onClose={() => setOpen2(false)}
              closeAfterTransition
              BackdropComponent={Backdrop}
              BackdropProps={{
                timeout: 500,
              }}
            >
              <Fade in={open2}>
                <div
                  style={{ borderRadius: "15px",
                    position: "absolute",
                    top: "50%",
                    backgroundColor: "white",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 400,
                    padding: "20px",
                  }}
                >
                  <div style={{ marginTop: "-25px" }}>
                    <div
                      style={{
                        marginTop: "20px",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <h3>Journey Information</h3>
                      <IconButton size="small">
                        <CloseIcon
                          onClick={() => setOpen2(false)}
                          style={{ color: themeStyle.primaryColor }}
                        />
                      </IconButton>
                    </div>

                    <br></br>
                    <br></br>
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        justifyContent: "flex-end",
                      }}
                    >
                      <Button
                        style={{ height: "30px", marginLeft: "10px", backgroundColor: themeStyle.primaryColor }}
                        variant="contained"
                        onClick={() => setOpen2(false)}
                      >
                        OK
                      </Button>
                    </div>
                  </div>
                </div>
              </Fade>
            </Modal>
            <Sidebar
            //   tabs={
            //     <Grid container spacing={1.5} justifyContent="flex-end">
            //       <Grid item md={2}>
            //         <Select
            //           value={year}
            //           // onChange={(e) => handleApprovalChange(e.target.value)}
            //           style={{
            //             marginTop: "2px",
            //             height: "40px",
            //             marginBottom: "5px",
            //           }}
            //           fullWidth
            //           variant={"outlined"}
            //         >
            //           <MenuItem value={"2025"}>2025</MenuItem>
            //         </Select>
            //       </Grid>{" "}
            //       <Grid item md={2}>
            //         <Select
            //           value={month}
            //           onChange={(e) => setMonth(e.target.value)}
            //           variant={"outlined"}
            //           fullWidth
            //           style={{
            //             marginTop: "2px",
            //             height: "40px",
            //             marginBottom: "5px",
            //           }}
            //         >
            //           <MenuItem value={1}>January</MenuItem>
            //           <MenuItem value={2}>February</MenuItem>
            //           <MenuItem value={3}>March</MenuItem>
            //           <MenuItem value={4}>April</MenuItem>
            //           <MenuItem value={5}>May</MenuItem>
            //           <MenuItem value={6}>June</MenuItem>
            //           <MenuItem value={7}>July</MenuItem>
            //           <MenuItem value={8}>August</MenuItem>
            //           <MenuItem value={9}>September</MenuItem>
            //           <MenuItem value={10}>October</MenuItem>
            //           <MenuItem value={11}>November</MenuItem>
            //           <MenuItem value={12}>December</MenuItem>
            //         </Select>
            //       </Grid>
            //     </Grid>
            //   }
            />
            <div
              style={{ borderRadius: "15px",
                margin: "38px 40px 20px 90px",
                backgroundColor: "white",
                display: "flex",
              }}
            >
              {getContent()}
            </div>
          </Fragment>
        );
      } else {
        createAlert("ERROR", "Permission Denied.", "Please Login as Student");
        dispatch({
          type: "AUTH_ERROR",
        });
        dispatch({ type: "AUTH_ERROR" });
      }
    } else {
      dispatch({ type: "AUTH_ERROR" });
    }
  } else {
    return (
      <div
        style={{ borderRadius: "15px",
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          backgroundColor: "white",
          marginTop: "46vh",
        }}
      >
        <CircularProgress />
      </div>
    );
  }
}

export default FeesParent;
